import React, { useState, useEffect } from 'react';
import axios from 'axios';

const fmt = (n) => n ? Number(n).toLocaleString('tr-TR') : '0';
const fmtTL = (n) => fmt(n) + ' TL';
const fmtTarih = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

const StatKart = ({ baslik, deger, renk, alt }) => (
  <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1rem 1.25rem' }}>
    <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>{baslik}</div>
    <div style={{ fontSize: '22px', fontWeight: '700', color: renk || '#111827' }}>{deger}</div>
    {alt && <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{alt}</div>}
  </div>
);

const Bolum = ({ baslik, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '1rem', paddingBottom: '6px', borderBottom: '1px solid #F3F4F6' }}>
      {baslik}
    </div>
    {children}
  </div>
);

const PersonelRaporuPage = () => {
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [filtre, setFiltre] = useState('hepsi');
  const [arama, setArama] = useState('');

  useEffect(() => {
    axios.get('/api/personel-rapor')
      .then(r => { setVeri(r.data); setYukleniyor(false); })
      .catch(() => setYukleniyor(false));
  }, []);

  if (yukleniyor) return <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Yukleniyor...</div>;
  if (!veri) return <div style={{ padding: '2rem', color: '#DC2626' }}>Veri yuklenemedi.</div>;

  const { personeller, ozet, musteri_dagilim } = veri;

  const filtrelenmis = personeller.filter(p => {
    if (filtre === 'outsource' && p.outsource !== 1) return false;
    if (filtre === 'dahili' && p.outsource === 1) return false;
    if (arama && !(p.ad + ' ' + p.soyad + ' ' + (p.musteri_adi || '') + ' ' + (p.pozisyon_adi || '')).toLowerCase().includes(arama.toLowerCase())) return false;
    return true;
  });

  return (
    <div>
      <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>Personel Raporu</h2>
          <p style={{ fontSize: '13px', color: '#6B7280' }}>Outsource ve dahili personel detayli raporu</p>
        </div>
        <button onClick={() => (() => { const t = localStorage.getItem('token'); fetch('/api/pdf-rapor/personel', {headers:{Authorization:'Bearer '+t}}).then(r=>r.blob()).then(b=>{const a=document.createElement('a');a.href=URL.createObjectURL(b);a.download='personel-raporu.pdf';a.click()}); })()}
          style={{ padding: '8px 16px', border: 'none', borderRadius: '8px', background: '#DC2626', color: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
          PDF Indir
        </button>
      </div>

      {/* Özet */}
      <Bolum baslik="Genel Ozet">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <StatKart baslik="Toplam Personel" deger={ozet.toplam} />
          <StatKart baslik="Outsource" deger={ozet.outsource} renk="#1a56db" />
          <StatKart baslik="Dahili" deger={ozet.dahili} renk="#6B7280" />
          <StatKart baslik="Toplam Maas" deger={fmtTL(ozet.toplam_maas)} renk="#DC2626" />
          <StatKart baslik="Toplam Fatura (KDV Haric)" deger={fmtTL(ozet.toplam_fatura)} renk="#059669" />
          <StatKart baslik="Toplam Fatura (KDV Dahil)" deger={fmtTL(ozet.toplam_fatura_kdv_dahil)} renk="#1a56db" />
          <StatKart baslik="Toplam Kar" deger={fmtTL(ozet.toplam_kar)} renk={ozet.toplam_kar >= 0 ? '#059669' : '#DC2626'} />
        </div>
      </Bolum>

      {/* Müşteri Dağılımı */}
      {musteri_dagilim.length > 0 && (
        <Bolum baslik="Musteri Dagilimi">
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Personel</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Toplam Maas</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Toplam Fatura</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Toplam Kar</th>
                  </tr>
                </thead>
                <tbody>
                  {musteri_dagilim.map((m, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '10px 16px', fontWeight: '500' }}>{m.musteri_adi}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                        <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '2px 10px', borderRadius: '99px', fontWeight: '600' }}>{m.personel_sayisi}</span>
                      </td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{fmtTL(m.toplam_maas)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669' }}>{fmtTL(m.toplam_fatura)}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: m.toplam_kar >= 0 ? '#059669' : '#DC2626' }}>
                        {m.toplam_kar >= 0 ? '+' : ''}{fmtTL(m.toplam_kar)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Bolum>
      )}

      {/* Personel Listesi */}
      <Bolum baslik={'Personel Listesi (' + filtrelenmis.length + ')'}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '1rem', flexWrap: 'wrap' }}>
          {[['hepsi','Hepsi'],['outsource','Outsource'],['dahili','Dahili']].map(([k,l]) => (
            <button key={k} onClick={() => setFiltre(k)}
              className={'btn btn-sm ' + (filtre === k ? 'btn-primary' : 'btn-secondary')}>
              {l}
            </button>
          ))}
          <input type="text" placeholder="Personel, musteri, pozisyon ara..." value={arama} onChange={e => setArama(e.target.value)}
            style={{ flex: 1, minWidth: '200px', padding: '6px 12px', border: '1px solid #E5E7EB', borderRadius: '6px', fontSize: '13px' }} />
        </div>

        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
          {filtrelenmis.length === 0 ? (
            <div style={{ padding: '3rem', textAlign: 'center', color: '#6B7280' }}>Personel bulunamadi</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Personel</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Tur</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Musteri</th>
                    <th style={{ padding: '10px 16px', textAlign: 'left', color: '#6B7280', fontWeight: '600' }}>Pozisyon</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Maas</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Fatura (KDV Haric)</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Fatura (KDV Dahil)</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Kar</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Perf.</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', color: '#6B7280', fontWeight: '600' }}>Baslangic</th>
                  </tr>
                </thead>
                <tbody>
                  {filtrelenmis.map((p, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '10px 16px' }}>
                        <div style={{ fontWeight: '500' }}>{p.ad} {p.soyad}</div>
                        <div style={{ fontSize: '11px', color: '#9CA3AF' }}>{p.email}</div>
                      </td>
                      <td style={{ padding: '10px 16px' }}>
                        <span style={{ background: p.outsource === 1 ? '#EEF2FF' : '#F3F4F6', color: p.outsource === 1 ? '#4F46E5' : '#6B7280', padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600' }}>
                          {p.outsource === 1 ? 'Outsource' : 'Dahili'}
                        </span>
                      </td>
                      <td style={{ padding: '10px 16px', color: '#374151' }}>{p.musteri_adi || '-'}</td>
                      <td style={{ padding: '10px 16px', color: '#374151' }}>{p.pozisyon_adi || '-'}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#DC2626' }}>{p.maas ? fmtTL(p.maas) : '-'}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>{p.fatura_kalemi ? fmtTL(p.fatura_kalemi) : '-'}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669' }}>{p.fatura_kdv_dahil ? fmtTL(Math.round(p.fatura_kdv_dahil)) : '-'}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: p.personel_kar >= 0 ? '#059669' : '#DC2626' }}>
                        {p.personel_kar != null ? (p.personel_kar >= 0 ? '+' : '') + fmtTL(p.personel_kar) : '-'}
                      </td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                        {p.son_performans_notu ? (
                          <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '2px 8px', borderRadius: '99px', fontSize: '11px', fontWeight: '600' }}>
                            {p.son_performans_notu} ({p.performans_yili})
                          </span>
                        ) : <span style={{ color: '#9CA3AF' }}>-</span>}
                      </td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#9CA3AF', fontSize: '12px' }}>
                        {fmtTarih(p.outsource_baslangic || p.ise_giris_tarihi)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Bolum>
    </div>
  );
};

export default PersonelRaporuPage;
